<template>
	<div class="time-chooser-container">
		<div class="slots" v-for="timeslotTime in dailyTimeslotsTimes">
			<div class="slot-title">{{ timeslotTime.slot.name }}</div>
			<div class="times-container" v-if="timeslotTime.times.length > 0">
				<div class="time" :class="{unavailable: !time.available}" v-for="time in timeslotTime.times" @click="clickTimeslot(time.time, timeslotTime.slot.experience_timeslot_id, time.available)">
					<div class="time-value">{{ time.time }}</div>
				</div>
			</div>
			<div class="no-times-container" v-else>
				<div class="no-times">
					<div class="no-times-title">{{ getString('no_times_available') }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {useReservationsStore} from "@/book/stores";
import {useMenusStore} from "@/new-menu/stores";
import {formatDateOnly} from "@/shared/helpers/dates";
import {useLanguageStore} from "@/shared/stores";
import { timeslotTimes } from "@/book/helpers/availabilities";

export default {
	setup() {
		const reservationsStore = useReservationsStore();
		const menusStore = useMenusStore();
		const languageStore = useLanguageStore();
		return {reservationsStore, menusStore, getString: languageStore.getString};
	},
	name: "TimeChooser",
	computed: {
		dailyTimeslots() {
			let slots = [];
			let foundException = false;
			for(let i = 0; i < this.reservationsStore.selectedExperience.exceptions.length; i++) {
				let exception = this.reservationsStore.selectedExperience.exceptions[i];
				if(exception.date === formatDateOnly(this.reservationsStore.chosenDate)) {
					slots = exception.timeslots;
					foundException = true;
					break;
				}
			}
			if(!foundException) {
				let weekday = this.reservationsStore.chosenDate.getDay();
				slots = this.reservationsStore.selectedExperience.timeslots.filter(t => ((t.weekday+1)%7) === weekday);
			}
			return slots;
		},
		dailyTimeslotsTimes() {
			let times = [];

			const date = formatDateOnly(this.reservationsStore.chosenDate);
			let reservations = [];
			let maxCapacity = null;
			if(this.reservationsStore.availabilities.experience_id === this.reservationsStore.selectedExperienceId && this.reservationsStore.availabilities.lastDate === date) {
				reservations = this.reservationsStore.availabilities.reservations[date];
				maxCapacity = this.reservationsStore.availabilities.maxCapacity;
			}

			this.dailyTimeslots.forEach(t => {
				times.push({
					slot: t,
					times: timeslotTimes(t, reservations, maxCapacity, this.isDateToday)
				});
			});
			return times;
		},
		isDateToday() {
			return formatDateOnly(new Date()) === formatDateOnly(this.reservationsStore.chosenDate);
		}
	},
	methods: {
		clickTimeslot(time, slotId, maxPeople) {
				this.reservationsStore.chosenTime.time = time;
				this.reservationsStore.chosenTime.slotId = slotId;
				this.reservationsStore.chosenTime.maxPeople = maxPeople;
		}
	},
}
</script>

<style scoped lang="scss">
.time-chooser-container {
	display: flex;
	flex-direction: column;
	background-color: var(--theme-bg2-color);
	width: 100%;
	border-radius: var(--rounded-corner);
	padding: var(--padding-vertical) var(--padding-horizontal);
	gap: calc(var(--padding-vertical) * 2);

	.slot-title {
		color: var(--theme-txt1-color);
		font-weight: 500;
		font-size: var(--font-size-xl);
		margin-bottom: var(--padding-vertical);
	}

	.no-times-container {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		color: var(--theme-txt2-color);
	}

	.times-container {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		flex-wrap: wrap;
		--num-items-row: 10;
		--gap: var(--padding-horizontal-s);
		gap: var(--gap);

		.time {
			display: flex;
			align-items: center;
			justify-content: center;
			width: calc((100% / var(--num-items-row)) - ((var(--gap) * (var(--num-items-row) - 1)) /var(--num-items-row)) );
			height: 40px;
			border-radius: var(--rounded-corner-s);
			border: 1px solid var(--business-color);
			font-weight: 500;
			font-size: var(--font-size);
			color: var(--business-text-color);
			cursor: pointer;
			background-color: var(--business-color-alpha40);
			transition: background-color 0.3s, color 0.3s;

			&.unavailable {
				background-color: var(--business-color-alpha20);
				color: var(--business-text-color-alpha20);
				cursor: not-allowed;
				pointer-events: none;
			}

			&:hover {
				background-color: var(--business-color-alpha80);
			}

			@media (max-width: 1200px) {
				--num-items-row: 8;
			}

			@media (max-width: 1024px) {
				--num-items-row: 10;
			}

			@media (max-width: 880px) {
				--num-items-row: 8;
			}

			@media (max-width: 720px) {
				--num-items-row: 7;
			}

			@media (max-width: 590px) {
				--num-items-row: 6;
			}

			@media (max-width: 490px) {
				--num-items-row: 5;
			}

			@media (max-width: 390px) {
				--num-items-row: 4;
			}

			@media (max-width: 320px) {
				--num-items-row: 3;
			}
		}

	}
}
</style>